import { render, staticRenderFns } from "./SoftwareMagoDisplay.vue?vue&type=template&id=6dff85d1&"
import script from "./SoftwareMagoDisplay.vue?vue&type=script&lang=ts&"
export * from "./SoftwareMagoDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SoftwareMagoDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dff85d1')) {
      api.createRecord('6dff85d1', component.options)
    } else {
      api.reload('6dff85d1', component.options)
    }
    module.hot.accept("./SoftwareMagoDisplay.vue?vue&type=template&id=6dff85d1&", function () {
      api.rerender('6dff85d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/SoftwareMagoDisplay.vue"
export default component.exports